// api/user.js
import request from "@/utils/request.js"

// 获取侧边联系
export function getFooter() {
  return request({
    url: '/getLateral?sort=asc',
    method: 'get',
  })
}
// 友情链接
export function getFriendlyLink() {
  return request({
    url: '/getFriend?limit=20',
    method: 'get',
  })
}
